// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__R4aKt","requiredAsterisk":"Info_requiredAsterisk__2Lh52"};